import BaseTool from "../../baseComponents/BaseTool";
import SliceWidget from "./SliceWidget";
import PointWidget from "./PointWidget";
import ViewWidget from "./ViewWidget";
import {memo, useEffect} from "react";
import {postSession} from "../../../utils/api";

const DEFAULTS = {
  sim_widget: {
    domain: 'cor',
    variable: 'br',
    time_of_interest: null,
  },
  slice_widget: {
    slice: 'r', 
    slice_param1: null, 
    slice_param2: null, 
    abs_transform: false,
    log_transform: false, 
    rad_transform: false,
    rad_transform_exponent: 0, 
    units: 'real', 
    show_text: true,
    line_width: 1,
    line_style: 'solid',
    marker_symbol: 'none',
    color: '#000000'
  },
  point_widget: {
    query_point: false,
    point_xvalue: null,
    line_width: 0.8,
    line_style: 'dashed',
    marker_symbol: 'o',
    color: '#A2000B',
    show_point: true,
    show_lines: true,
    show_text: true,
  },
  view_widget: {
    xaxis_min: null,
    xaxis_max: null,
    xaxis_ticks: null,
    yaxis_min: null,
    yaxis_max: null,
    yaxis_ticks: null,
    grid: null,
  },
}

const sharedData = {
  slice_widget: {slice: null}
}

const Plot1d = ({id, setId}) => {
  return (
    <>
      <BaseTool
        id={id}
        setId={setId}
        tool='plot1d'
        toolName='PLOT1D'
        sharedDeps={sharedData}
        defaults={DEFAULTS}
        sliceWidget={SliceWidget}
        pointWidget={PointWidget}
        viewWidget={ViewWidget}
      />
    </>

  )
}

export default memo(Plot1d);